import React from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import BrokerCommissionItem from './BrokerCommissionItem';
import AddItem from '../../../nucleus/add-item/add-item';
import { createCommission } from '../../../redux/actions/commissions-actions';


const selectCommissionsByIds = state => state.commissions.commissions
  .filter(({ cbre_broker_type }) => cbre_broker_type === 'employee')
  .map(({ id }) => id);

const BrokerCommissions = ({
  dealId, deal_type, voucherId, showValidation, cbre_commission_is_percent, shouldAddAsLeadBroker,
}) => {
  const dispatch = useDispatch();
  const commissionIds = useSelector(selectCommissionsByIds, shallowEqual);
  return (
    <div className="financials-section-wrapper">
      {commissionIds.map(id => (
        <BrokerCommissionItem
          key={id}
          id={id}
          dealId={dealId}
          deal_type={deal_type}
          voucherId={voucherId}
          showValidation={showValidation}
          cbre_commission_is_percent={cbre_commission_is_percent}
        />
      ))}
      <div>
        <AddItem
          label="Add Broker"
          onClick={() => dispatch(createCommission({
            broker_is_lead: shouldAddAsLeadBroker,
            cbre_broker_type: 'employee',
            payment_group: 1,
            transaction: dealId,
          }))}
        />
      </div>
    </div>
  );
};

BrokerCommissions.propTypes = {
  showValidation: PropTypes.bool.isRequired,
  dealId: PropTypes.number.isRequired,
  deal_type: PropTypes.string.isRequired,
  voucherId: PropTypes.number.isRequired,
  cbre_commission_is_percent: PropTypes.bool.isRequired,
  shouldAddAsLeadBroker: PropTypes.bool.isRequired,
};

export default BrokerCommissions;
